import { api } from "../../lib";

export interface Correction {
  id: string;
  correction: string;
  description: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCorrectionInput {
  correction: string;
  description?: string;
  isActive?: boolean;
}

export interface UpdateCorrectionInput extends Partial<CreateCorrectionInput> {
  id: string;
}

export const correctionsService = {
  getAll: async () => {
    return api.get<Correction[]>("/admin/corrections");
  },

  getById: async (id: string) => {
    return api.get<Correction>(`/admin/corrections/${id}`);
  },

  create: async (input: CreateCorrectionInput) => {
    return api.post<Correction>("/admin/corrections", input);
  },

  update: async (input: UpdateCorrectionInput) => {
    const { id, ...updates } = input;
    return api.put<Correction>(`/admin/corrections/${id}`, updates);
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/corrections/${id}`);
  },

  toggleActive: async (id: string, isActive: boolean) => {
    return api.put<Correction>(`/admin/corrections/${id}`, { isActive });
  },
};
